import styled from 'styled-components';

import { colorsPalettes, setFontVariant } from '@similarweb/styles';

export const StyledActivityCard = styled.div`
  padding: 12px;
  background-color: ${colorsPalettes.bluegrey[100]};
  border-radius: 6px;
  width: 100%;
`;

export const StyledActivityCardHeader = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 8px;
  margin-bottom: 8px;
`;

export const StyledActivityTitle = styled.div`
  ${setFontVariant('body2', colorsPalettes.carbon[500])};
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
`;

export const StyledActivityCardBody = styled.div`
  display: flex;
  flex-direction: column;
  gap: 4px;
`;

export const StyledActivityCardInfo = styled.div`
  display: flex;
  align-items: center;
  justify-content: flex-start;
  gap: 8px;
`;

export const StyledActivityCardInfoText = styled.div`
  ${setFontVariant('caption', colorsPalettes.carbon[400])};
`;

export const StyledActivityStatus = styled.div`
  ${setFontVariant('caption', colorsPalettes.carbon[250])};
  margin-left: auto;
  white-space: nowrap;
`;

export const StyledActivityDescription = styled.div`
  ${setFontVariant('body2', colorsPalettes.carbon[400])};
  display: -webkit-box;
  -webkit-line-clamp: 3;
  -webkit-box-orient: vertical;
  overflow: hidden;
  white-space: normal;
  text-overflow: ellipsis;
`;
